module.exports = __webpack_public_path__ + "static/media/centri-di-costo.db91dfcb.odt";